// extracted by mini-css-extract-plugin
module.exports = {"labelWrapper":"Active_labelWrapper__1wCuL","buttonWrapper":"Active_buttonWrapper__3nsHR"};